<template>
  <div class="sky-tool-list-page">
    <div class="tool-page-content">
      <el-tabs v-model="activeName" @tab-click="handleClick()">
        <el-tab-pane :label="item.label" :name="item.value" v-for="(item, tableIndex) in tabArr" :key="item.value">
          <div class="wsp-display-flex tool-list-content">
            <div v-for="item in toolInfoItem" :key="item.toolName" class="tool-item">
              <el-card>
                <div class="card-content">
                  <div class="tool-item-icon wsp-tool-dow-btn-center">
                    <img v-show="item.loadingEnd" :src="item.logoBase64Data" style="width: 58px; height: 58px;" />
                    <img
                      v-show="!item.loadingEnd"
                      src="../../assets/images/hanlin.png"
                      style="width: 58px; height: 58px;"
                    />
                  </div>
                  <div class="tool-item-description" :ref="item.id + '-heder-parent'">
                    <el-tooltip placement="top" :disabled="isShowTooltipHeader">
                      <div slot="content">
                        <div>
                          {{ item.toolDesc }}
                        </div>
                      </div>
                      <div
                        :ref="item.id + '-heder'"
                        class="card-header wsp-tool-app-description-1-line-hidder "
                        @mouseover="checkContentHeaderOverflow(item.id, tableIndex)"
                      >
                        {{ item.toolDesc }}
                      </div>
                    </el-tooltip>

                    <div class="wsp-tool-app-description-3-line-hidder" :ref="item.id + '-parent'">
                      <el-tooltip placement="top" :disabled="isShowTooltip">
                        <div slot="content">
                          <span class="card-text">
                            {{ item.toolDetail }}
                          </span>
                        </div>
                        <span :ref="item.id" class="card-text" @mouseover="checkContentOverflow(item.id, tableIndex)">
                          {{ item.toolDetail }}
                        </span>
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="wsp-tool-dow-btn tool-item-btn wsp-tool-dow-btn-center">
                    <el-button round size="small" type="text" @click="toolDownload(item)">
                      点击访问
                    </el-button>
                  </div>
                </div>
              </el-card>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { Card, Row, Col, Button, Tabs, TabPane, Tooltip } from 'element-ui'

import { createNps, findNeedNps } from '@/api/nps'
import { getToolLogo, getTool, getToolUrl } from '@/api/tool'
import FeedbackDialog from '@/components/FeedbackDialog'
export default {
  name: 'tool',
  components: {
    [Card.name]: Card,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Tooltip.name]: Tooltip
  },
  data() {
    return {
      toolInfo: [],
      toolInfoItem: [],
      activeName: 'all',
      isShowTooltip: true,
      isShowTooltipHeader: true,
      tabMap: {},
      tabArr: [
        {
          label: '全部',
          value: 'all'
        }
      ],
      imageObj: {}
    }
  },
  computed: {
    toolArr() {
      var infoSize = Math.ceil(this.toolInfo.length / 3)
      var infoArr = []
      for (let index = 0; index < infoSize; index++) {
        infoArr.push(index)
      }
      return infoArr
    }
  },
  mounted() {
    this.getTools(this.activeName)
  },
  methods: {
    checkContentOverflow(id, index) {
      const contentWrapperPa = this.$refs[id + '-parent'][index]
      const contentWrapper = this.$refs[id][index]
      var aa = contentWrapper.offsetHeight > contentWrapperPa.offsetHeight
      this.isShowTooltip = !aa
    },
    checkContentHeaderOverflow(id, index) {
      const contentWrapperPa = this.$refs[id + '-heder-parent'][index]
      const contentWrapper = this.$refs[id + '-heder'][index]

      var aa = contentWrapper.scrollWidth > contentWrapperPa.clientWidth
      this.isShowTooltipHeader = !aa
    },
    getTools(toolCategory) {
      var temp = []
      getTool({ id: '4a25288b-6e8b-4ad4-86ea-67a79fc1c1c3' }).then(res => {
        temp.push(res.data.content)
        if (temp && temp.length > 0) {
          for (let index = 0; index < temp.length; index++) {
            const element = temp[index]
            element.loadingEnd = false
            element.logoBase64Data = null
            this.fetchToolLogo(element.id, index)
          }
        }
        this.toolInfo = temp
        this.toolInfoItem = temp
      })
    },
    toolDownload(item) {
      const _this = this
      if (item.id) {
        //二次下载并且经过一段时间后进行填写反馈
        const params = { toolId: item.id }
        findNeedNps(params).then(res => {
          const nps = res.data.content
          if (nps.toolId) {
            var title = '问题反馈与建议'
            var dialog = this.$root.$dialog({
              template: h => {
                const feedback = params
                const isModel = true
                const sourceFrom = 'nps'
                return (
                  <sky-feedback-dialog
                    feedback={feedback}
                    isModel={isModel}
                    sourceFrom={sourceFrom}
                    onCb={function() {
                      dialog.remove()
                      //如果有需要NPS采集，则先nps采集再下载
                      _this.download(item)
                    }}
                  />
                )
              },
              components: {
                FeedbackDialog
              },
              props: {
                title: title,
                width: '45%',
                showClose: false,
                showDefaultFooter: false,
                closeOnPressEscape: false
              }
            })
          } else {
            createNps({ toolId: item.id, npsStrategy: 'FIRST_USE' })
            _this.download(item)
          }
        })
      }
    },
    download(item) {
      if (item && item.provideMode === 'PROTECTION') {
        getToolUrl({ id: item.id })
          .then(response => {
            window.open(response.data.content, '_blank')
          })
          .catch(e => {
            throw e
          })
      } else {
        window.open(item.toolUrl, '_blank')
      }
    },
    fetchToolLogo(id, index) {
      if (id) {
        getToolLogo({ id: id })
          .then(response => {
            this.$set(this.toolInfo[index], 'logoBase64Data', response.data.content)
            this.$set(this.toolInfo[index], 'loadingEnd', true)
          })
          .catch(e => {
            throw e
          })
      }
    },
    handleClick() {
      if (this.activeName === 'all') {
        this.toolInfoItem = this.toolInfo
      } else {
        this.toolInfoItem = this.toolInfo.filter(one => one.toolCategory.indexOf(this.activeName) != -1)
      }
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/mixin/mixin';
@import '~sky-engine/assets/styles/common/var.scss';
@include b(tool-list-page) {
  height: 888px;
  padding: 12px;
  padding-bottom: 24px;
  .tool-page-content {
    height: 100%;
    overflow-y: auto;
  }
  .tool-list-content {
    flex-wrap: wrap;
    padding: 0 64px;
    .tool-item {
      width: 24.5%;
      padding: 3px;
      .tool-item-icon {
        width: 20%;
        padding: 0 3px;
      }
      .tool-item-description {
        width: 65%;
        padding: 0 12px;
      }
      .tool-item-btn {
        width: 15%;
        font-size: 14px;
      }
      .wsp-tool-dow-btn-center {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .wsp-tool-app-description-3-line-hidder {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    line-height: 18px;
    font-size: 12px;
    color: #5e5e5e;
    text-overflow: ellipsis;
  }

  .wsp-tool-app-description-1-line-hidder {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .card-content {
    display: flex;
  }
  .card-header {
    font-size: 18px;
    padding: 6px 0 6px 0px;
    font-weight: bold;
  }
  .card-text {
    font-size: 12px;
  }
  .el-card__body {
    padding: 8px 12px;
  }
  .el-card {
    width: 100%;
    height: 96px;
  }
}
</style>
<style></style>
